import React from "react"

// components
import { Space, Typography, Tag } from "antd"

// context
import { orderBy, groupBy } from "lodash-es"

const OrderItemList = ({ items }) => {
  return (
    <Space wrap direction="vertical">
      {orderBy(
        Object.entries(groupBy(items, "hash")),
        (item) => item[0],
        "asc"
      ).map(([id, list]) => (
        <Tag style={{ border: "none" }} key={id}>
          <Space wrap>
            <Typography.Text italic>{list.length}x</Typography.Text>
            <Typography.Text type="secondary">|</Typography.Text>
            <Typography.Text>
              <Typography.Text strong>{list[0].id}</Typography.Text>{" "}
              <Typography.Text
                style={{
                  whiteSpace: "break-spaces",
                }}
              >
                {list[0].name}
              </Typography.Text>
            </Typography.Text>
            {list[0].settings &&
              list[0].choices &&
              Object.entries(list[0].choices).map(([key, value]) => {
                const setting = list[0].settings.find(
                  (s) => String(s.key) === String(key)
                )
                if (!setting) return null

                switch (setting.type) {
                  case "checkbox":
                    return value.map((v) => {
                      const option = setting.options.find(
                        (opt) => opt.value === v
                      )

                      return (
                        <Tag key={`${key}-${v}`}>
                          {setting.label}: {option ? option.label : v || "—"}
                        </Tag>
                      )
                    })
                  case "radio":
                    const option = setting.options.find(
                      (opt) => opt.value === value
                    )
                    return (
                      <Tag key={key}>
                        {setting.label}: {option ? option.label : value || "—"}
                      </Tag>
                    )
                  default:
                    return null
                }
              })}
          </Space>
        </Tag>
      ))}
    </Space>
  )
}

export default OrderItemList
